export default {
	'{days}天后': '{days}天后',
	今日到期: '今日到期',
	'已过期{days}天': '已过期{days}天',
}
